export const keys = {
  banner: {
    title: 'banner.title',
  },
};
